import { Expose, Type } from "class-transformer";
import { IsArray, ValidateNested } from "class-validator";
import { CategoryEntity } from "../../entity";

export class ListAllCategoryDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => CategoryEntity)
  categories!: CategoryEntity[];
}
